import { render, staticRenderFns } from "./joinpay.vue?vue&type=template&id=332d34ac&scoped=true&"
import script from "./joinpay.vue?vue&type=script&lang=js&"
export * from "./joinpay.vue?vue&type=script&lang=js&"
import style0 from "./joinpay.vue?vue&type=style&index=0&id=332d34ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332d34ac",
  null
  
)

export default component.exports